import { Dispatch, SetStateAction, useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router';
import {
    ADMINISTRATION_SEARCH_QUERY_KEY,
    AdministrationSearchFilters,
    applyAdministrationSearchToSearchParams
} from './administrationNavigation';

export const useAdministrationSearchUrlSync = <
  T extends AdministrationSearchFilters
>(
  setFilters: Dispatch<SetStateAction<T>>
) => {
  const [searchParameters, setSearchParameters] = useSearchParams();
  const urlSearch = searchParameters.get(ADMINISTRATION_SEARCH_QUERY_KEY) ?? '';

  useEffect(() => {
    setFilters((current) => {
      if (
        current.appliedSearch === urlSearch &&
        current.searchInput === urlSearch
      ) {
        return current;
      }
      return {
        ...current,
        searchInput: urlSearch,
        appliedSearch: urlSearch,
        page: 0
      };
    });
  }, [urlSearch, setFilters]);

  const commitSearchToUrl = useCallback(
    (searchValue: string) => {
      setSearchParameters(
        (current) =>
          applyAdministrationSearchToSearchParams(current, searchValue),
        { replace: true }
      );
    },
    [setSearchParameters]
  );

  return { commitSearchToUrl };
};
